import Service from "../AuthService";

const QualityControl = {
    getQualityDate(request) {
        return Service.get(`quality-date?date=${request.date}`);
    },
    getFilterQuality(request) {
        return Service.post(`filter-quality`, request);
    },
    approveQuality(request) {
        return Service.post(`approve-quality`, request);
    },
    getTestItemAll() {
        return Service.get(`test-item-all`);
    },
    getQCNameAll() {
        return Service.get(`qc-name-all`);
    },
    getLotNumberAll() {
        return Service.get(`lot-no-all`);
    }
};

export default QualityControl;
